import Vue from 'vue'
import El from './El.vue'

const ElConstructor = Vue.extend(El)

function downloadLamp(src, insects) {
  const instance = new ElConstructor({
    propsData: { src, insects }
  })

  instance.vm = instance.$mount()
  document.body.appendChild(instance.vm.$el)
}

export default downloadLamp
